/* Datei: src/pages/BlogAdmin/BlogManagement.js */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config/config';
import './BlogManagement.css';

const BlogManagement = () => {
  const [blogEntries, setBlogEntries] = useState([]);

  useEffect(() => {
    fetchBlogEntries();
  }, []);

  const fetchBlogEntries = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/blog-entries`);
      setBlogEntries(response.data);
    } catch (error) {
      console.error('Error fetching blog entries:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Möchten Sie diesen Blog-Eintrag wirklich löschen?')) {
      try {
        await axios.delete(`${API_BASE_URL}/blog-entries/${id}`);
        fetchBlogEntries();
      } catch (error) {
        console.error('Error deleting blog entry:', error);
      }
    }
  };

  const handleToggleVisibility = async (entry) => {
    try {
      const updated = { ...entry, approved: !entry.approved };
      await axios.put(`${API_BASE_URL}/blog-entries/${entry.id}`, updated);
      fetchBlogEntries();
    } catch (error) {
      console.error('Error updating blog entry:', error);
    }
  };

  return (
    <div className="blog-admin-card">
      <div>
        <h2>Blog-Eintraege verwalten</h2>
        <p className="blog-admin-section-copy">
          Sichtbarkeit und Loeschaktionen bleiben als operative Inhaltsliste in derselben Shell verfuegbar.
        </p>
      </div>
      <div className="blog-admin-table-wrap">
        <table className="blog-admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Titel</th>
              <th>Veroeffentlicht am</th>
              <th>Status</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {blogEntries.length ? blogEntries.map((entry) => (
              <tr key={entry.id}>
                <td>{entry.id}</td>
                <td>{entry.title || "Ohne Titel"}</td>
                <td>{entry.created_at || "-"}</td>
                <td>
                  <span className={`blog-admin-status${entry.approved ? " is-active" : ""}`}>
                    {entry.approved ? "Sichtbar" : "Unsichtbar"}
                  </span>
                </td>
                <td>
                  <div className="blog-admin-row-actions">
                    <button onClick={() => handleToggleVisibility(entry)} className="blog-admin-button blog-admin-button--warning">
                      {entry.approved ? "Ausblenden" : "Einblenden"}
                    </button>
                    <button onClick={() => handleDelete(entry.id)} className="blog-admin-button blog-admin-button--danger">
                      Loeschen
                    </button>
                  </div>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="5">
                  <div className="blog-admin-empty">Keine Blog-Eintraege vorhanden.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BlogManagement;
